<div class="card-default">
  <img src="assets/media/images/home/circles.png">
  <div class="card-default-info">
    <h3>{{data?.mainCard?.title ?? ''}}</h3>
    <p>{{data?.mainCard?.subtitle ?? ''}}</p>
    <a [routerLink]="'/verify-documents'">{{data?.mainCard?.action ?? ''}}</a>
  </div>
</div>
